import { GetDoctorInfo } from '@/api/endpoints/Doctors'
import { LoadListDefault, useGet } from '@/api/hooks'
import { useParams } from 'react-router-dom'
import EditedInfoSkeleton from './skeleton'
import EditedInfo from './editedInfo'

const DoctorDetails = () => {

  const { doctorId } = useParams()
  const { result: doctorDetails, isPending } = useGet({
    ...LoadListDefault,
    endPoint:GetDoctorInfo,
    params: [doctorId],
    depArr: [doctorId],
    defaultValue: {
      doctorName: '',
      doctorNameEn: '',
      bio: '',
      bioEn: '',
      birthDate: '',
      specialty: '',
      department: '',
    }, allowFetch: true
  })

  


  return <>
    <EditedInfoSkeleton isLoading={isPending} />
    <EditedInfo data={doctorDetails} isLoading={isPending} />
  </>
}

export default DoctorDetails